import React from 'react'

const MyGoals = () => {
  return (
    <div>MyGoals</div>
  )
}

export default MyGoals